import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const skipLazyLoad: AdminBlockTypeAttribute = {
  label: 'SkipLazyLoad',
  key: 'skipLazyLoad',
  inputType: AdminBlockAttributeInputType.HIDDEN,
};

export default skipLazyLoad;
